import * as ActionTypes from './constants';
import * as api from '../../../services/api';
import {
  isAuthenticated,
  storeIsAuthenticated
} from '../../../utils/session-util';
import normalizeAppConfigs from '../../../utils/app-config-util';

export function authenticate(username, password) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.START_LOADING
    });
    return api.auth
      .login(username, password)
      .then((response) => {
        storeIsAuthenticated(response.data.token);
        getLoginItemsPayload()
          .then((payload) => {
            dispatch(payload);
            dispatch({
              type: ActionTypes.STOP_LOADING
            });
          })
          .catch((error) => {
            dispatch({
              type: ActionTypes.STOP_LOADING
            });
            throw error;
          });
      })
      .catch((error) => {
        dispatch({
          type: ActionTypes.AUTHENTICATE_ERROR,
          authenticated: false,
          errorMessage:
            !!error.response && !!error.response.data
              ? error.response.data.message
              : error.message
        });
        dispatch({
          type: ActionTypes.STOP_LOADING
        });
        throw error;
      });
  };
}

export function getLoginItems() {
  if (!isAuthenticated()) {
    return (dispatch) =>
      dispatch({
        type: 'NOOP'
      });
  }
  return (dispatch) => {
    dispatch({
      type: ActionTypes.START_LOADING
    });
    getLoginItemsPayload().then((payload) => {
      dispatch(payload);
      dispatch({
        type: ActionTypes.STOP_LOADING
      });
    });
  };
}

const getLoginItemsPayload = () =>
  Promise.all([
    api.deliveryFrequencies.get(),
    api.branches.get(true),
    api.appCodes.getPriceReasonCodes(),
    api.routes.getEmployeeRoutes(),
    api.districts.getEmployeeDistricts(),
    api.applicationConfigurations.getApplicationConfigurations()
  ])
    .then((responses) => {
      const [
        deliveryFrequencies,
        branches,
        priceReasonCodes,
        routes,
        districts,
        appConfigs
      ] = responses;
      return {
        type: ActionTypes.STORE_LOGIN_ITEMS,
        deliveryFrequencies: deliveryFrequencies.data,
        branches: branches.data.content,
        routes: routes.data,
        districts: districts.data,
        priceReasonCodes: priceReasonCodes.data.map((reasonCode) => ({
          reasonId: reasonCode.codeValue,
          reason: reasonCode.codeLabel
        })),
        appConfigs: normalizeAppConfigs(appConfigs.data)
      };
    })
    .catch((err) => {
      return {
        type: ActionTypes.STOP_LOADING
      };
    });

export function signOut() {
  return {
    type: ActionTypes.SIGN_OUT
  };
}

export function openMenuItem(item) {
  return {
    type: ActionTypes.OPEN_MENU_ITEM,
    item
  };
}

export function setActiveBranch(branchId) {
  return {
    type: ActionTypes.SET_ACTIVE_BRANCH,
    branchId
  };
}

export function setAdminsSelectedBranches(branches) {
  return {
    type: ActionTypes.STORE_ADMIN_SELECTED_BRANCHES,
    branches
  };
}

export function updateAppConfigs(appConfigs) {
  return {
    type: ActionTypes.UPDATE_APP_CONFIG,
    appConfigs
  };
}
